




































































































import Vue from "vue";
import eventBus from "@/services/eventBus";
import SpecialDimensionApi from "@/modules/specialDimension/services/SpecialDimensionApi";
import SpecialDimension from "@/modules/specialDimension/models/SpecialDimension";

interface Data {
  menuOpen: boolean;
  loading: boolean;
  saving: boolean;
  rows: SpecialDimension[];
}

interface Methods {
  load(): Promise<void>;
  save(): Promise<void>;
  cancel(): void;
}

interface Computed {
  /** Pontosan EGY kontextus (bizonylat fej VAGY tétel) van megadva. */
  contextValid: boolean;
  contextValidTitle: string;
  isDisabled: boolean;
  activatorTitle: string;
}

interface Props {
  code: string;
  invHead: number;
  invItem: number;
  variant: string;
  label: string;
  icon: string;
  disabled: boolean;
  disabledReason: string;
}


export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    /** Bizonylat prefix (rlgeninvspecdim.code) */
    code: { type: String, required: true },
    /** Bizonylat fej azonosító (rlgeninvspecdim.inv_head) */
    invHead: { type: Number, default: 0 },
    /** Bizonylat tétel azonosító (rlgeninvspecdim.inv_item) */
    invItem: { type: Number, default: 0 },
    /** "icon" => ikon gomb, bármi más => szöveges gomb */
    variant: { type: String, default: "icon" },
    /** Szöveges gomb felirata */
    label: { type: String, default: "Speciális dimenziók" },
    /** Ikon gomb ikonja */
    icon: { type: String, default: "fa-line-chart" },
    /** Üzleti tiltás a szülőtől (pl. fej↔tétel kizárás) — a gomb nem nyitható */
    disabled: { type: Boolean, default: false },
    /** A tiltás oka, tooltip/title-ként jelenik meg */
    disabledReason: { type: String, default: "" },
  },

  data(): Data {
    return {
      menuOpen: false,
      loading: false,
      saving: false,
      rows: [],
    };
  },

  computed: {
    contextValid(): boolean {
      // Pontosan egy kell: vagy bizonylat fej, vagy bizonylat tétel (XOR).
      return (this.invHead > 0) !== (this.invItem > 0);
    },
    contextValidTitle(): string {
      return this.contextValid
        ? ""
        : "Speciális dimenzió csak bizonylat fejhez VAGY tételhez rögzíthető (pontosan egyhez).";
    },
    isDisabled(): boolean {
      return !this.contextValid || this.disabled;
    },
    activatorTitle(): string {
      if (!this.contextValid) return this.contextValidTitle;
      if (this.disabled) return this.disabledReason;
      return "";
    },
  },

  mounted() {
    if (!this.contextValid) {
      // Fejlesztői hiba: a szülő hibásan adta át a kontextust.
      // eslint-disable-next-line no-console
      console.warn(
        "[SpecialDimensionButton] Pontosan egy kontextus kötelező: " +
          "invHead VAGY invItem (nem mindkettő, és nem egyik sem)."
      );
    }
  },


  watch: {
    menuOpen(open: boolean) {
      if (open) {
        this.load();
      }
    },
  },

  methods: {
    async load() {
      if (!this.contextValid) {
        this.rows = [];
        return;
      }
      this.loading = true;
      try {
        const data = await SpecialDimensionApi.getRelations(
          this.code,
          this.invHead,
          this.invItem
        );
        this.rows = data.map((d) => ({
          specDimType: d.specDimType,
          name: d.name,
          // A note a szerverről jön: meglévő rögzített érték, vagy a bizonylat prefixhez
          // tartozó resolver alapértéke (pl. GENI: alvázszám/rendszám), egyébként üres.
          note: d.note ?? "",
        }));
      } finally {
        this.loading = false;
      }
    },

    async save() {
      if (!this.contextValid) {
        eventBus.$emit("error", this.contextValidTitle);
        return;
      }
      this.saving = true;
      try {
        await SpecialDimensionApi.saveRelations({
          code: this.code,
          invHead: this.invHead,
          invItem: this.invItem,
          items: this.rows,
        });
        eventBus.$emit("success", "Speciális dimenziók mentve.");
        // A mentett sorok mennek a szülőnek, hogy frissíthesse a saját állapotát
        // (pl. a tranzakció-szerkesztő fej↔tétel kizárásához a store fej spec dimjeit)
        this.$emit("saved", this.rows);
        this.menuOpen = false;
      } catch {
        // A hibaüzenet a handleApiResponse-ban már megjelent.
      } finally {
        this.saving = false;
      }
    },

    cancel() {
      this.menuOpen = false;
    },
  },
});
